import Vue from 'vue'
import axios from 'axios'

// const BASE_URL = 'http://192.168.1.47:8081' // 朱盼
// const BASE_URL = 'http://192.168.1.134:8081' // 桂金

// const BASE_URL = 'http://192.168.1.124:8081' // 潘满园
//  const BASE_URL = 'http://192.168.1.7:8081' // 陈帅伟
// const BASE_URL = 'https://5534fubp0371.vicp.fun'
const BASE_URL = 'https://test.feishazoushi.cn/admin' // 测试服务器

// const BASE_URL = 'http://neol.mynatapp.cc' // 映射地址
// const BASE_URL = 'https://feishazoushi.cn/admin' // 线上地址
axios.interceptors.request.use(
  config => {
    var token = sessionStorage.getItem('token')
    if (token && token != '') config.headers['token'] = token
    {
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.defaults.timeout = 120000 // 在超时时间
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8' // 配 置请求头
axios.defaults.baseURL = BASE_URL
axios.defaults.withCredentials = true
Vue.prototype.axios = axios
